Object.defineProperty(exports,"__esModule",{value:true});








var toTransformString=function toTransformString(obj){for(var _len=arguments.length,more=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){more[_key-1]=arguments[_key];}
if(more.length>0){
return more.reduce(function(memo,currentObj){
return[memo,toTransformString(currentObj)].join(" ");
},toTransformString(obj));
}else{
if(!obj||typeof obj==="string"){
return obj;
}
var transforms=[];
for(var key in obj){
if(obj.hasOwnProperty(key)){
var value=obj[key];
transforms.push(key+"("+value+")");
}
}
return transforms.join(" ");
}
};exports.default=

{

toTransformString:toTransformString,








getColorScale:function getColorScale(name){
var scales={
grayscale:[
"#cccccc","#969696","#636363","#252525"],

qualitative:[
"#334D5C","#45B29D","#EFC94C","#E27A3F","#DF5A49",
"#4F7DA1","#55DBC1","#EFDA97","#E2A37F","#DF948A"],

heatmap:["#428517","#77D200","#D6D305","#EC8E19","#C92B05"],
warm:["#940031","#C43343","#DC5429","#FF821D","#FFAF55"],
cool:["#2746B9","#0B69D4","#2794DB","#31BB76","#60E83B"],
red:["#FCAE91","#FB6A4A","#DE2D26","#A50F15","#750B0E"],
blue:["#002C61","#004B8F","#006BC9","#3795E5","#65B4F4"],
green:["#354722","#466631","#649146","#8AB25C","#A9C97E"]};

return name?scales[name]:scales.greyscale;
}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-util/style.js
// module id = 1489
// module chunks = 0